import { Component, OnInit, Input } from '@angular/core';
import { Avatar } from 'src/app/interfaces/game';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  @Input() casellaCorrente!: number;
  @Input() tiriDado!: number;
  @Input() puntiSostenibilita!: number;
  @Input() avatar!: Avatar | null;
  @Input() showFooter!: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
